import React, { useCallback, useEffect, useState } from "react";
import { StatsInvoice } from "../common/home/Stats";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import ntb from "../../assets/images/icon_topup/bntb.svg";
import bersama from "../../assets/images/icon_topup/bersama.svg";
import bsi from "../../assets/images/icon_topup/bsi.svg";
import Alfa from "../../assets/images/icon_topup/Alfa.svg";
import bankJatim from "../../assets/images/icon_topup/bankJatim.svg";
import bankntb from "../../assets/images/icon_topup/bankntb.svg";
import bankntbsy from "../../assets/images/icon_topup/bankntbsy.svg";
import bca from "../../assets/images/icon_topup/bca.svg";
import bjb from "../../assets/images/icon_topup/bjb.svg";
import bnis from "../../assets/images/icon_topup/bnis.svg";
import bri from "../../assets/images/icon_topup/bri.svg";
import btpn from "../../assets/images/icon_topup/btpn.svg";
import cimb from "../../assets/images/icon_topup/cimb.svg";
import dana from "../../assets/images/icon_topup/dana.svg";
import danamon from "../../assets/images/icon_topup/danamon.svg";
import indo from "../../assets/images/icon_topup/indo.svg";
import linkaja from "../../assets/images/icon_topup/linkaja.svg";
import mandiri from "../../assets/images/icon_topup/mandiri.svg";
import maybank from "../../assets/images/icon_topup/maybank.svg";
import muamalat from "../../assets/images/icon_topup/muamalat.svg";
import nobu from "../../assets/images/icon_topup/nobu.svg";
import ocbc from "../../assets/images/icon_topup/ocbc.svg";
import ovo from "../../assets/images/icon_topup/ovo.svg";
import permatasyariah from "../../assets/images/icon_topup/permatasyariah.svg";
import shopee from "../../assets/images/icon_topup/shopee.svg";
import bjs from "../../assets/images/icon_topup/bjs.svg";
import bni from "../../assets/images/icon_topup/bni.svg";
import permata from "../../assets/images/icon_topup/permata.svg";
import bntb from "../../assets/images/icon_topup/bntb.svg";
import image1 from "../../assets/images/idn/image1.png";
import image2 from "../../assets/images/idn/image2.png";
import image3 from "../../assets/images/idn/image3.png";
import image4 from "../../assets/images/idn/image4.png";
import image5 from "../../assets/images/idn/image5.png";
import image6 from "../../assets/images/idn/image6.png";
import image7 from "../../assets/images/idn/image7.png";
import image8 from "../../assets/images/idn/image8.png";
import image9 from "../../assets/images/idn/image9.png";
import image10 from "../../assets/images/idn/image10.png";
import image11 from "../../assets/images/idn/image11.png";
import image12 from "../../assets/images/idn/image12.png";
import image13 from "../../assets/images/idn/image13.png";
import image14 from "../../assets/images/idn/image14.png";
import image15 from "../../assets/images/idn/image15.png";
import image16 from "../../assets/images/idn/image16.png";
import image17 from "../../assets/images/idn/image17.png";
import image18 from "../../assets/images/idn/image18.png";
import image19 from "../../assets/images/idn/image19.png";
import image20 from "../../assets/images/idn/image20.png";
import image21 from "../../assets/images/idn/image21.png";
import image22 from "../../assets/images/idn/image22.png";
import image23 from "../../assets/images/idn/image23.png";
import image24 from "../../assets/images/idn/image24.png";
import image25 from "../../assets/images/idn/image25.png";
import image26 from "../../assets/images/idn/image26.png";
import image27 from "../../assets/images/idn/image27.png";
import image28 from "../../assets/images/idn/image28.png";
import image29 from "../../assets/images/idn/image29.png";
import image30 from "../../assets/images/idn/image30.png";
import image31 from "../../assets/images/idn/image31.png";
import image32 from "../../assets/images/idn/image32.png";
import image33 from "../../assets/images/idn/image33.png";
import image34 from "../../assets/images/idn/image34.png";
import image35 from "../../assets/images/idn/image35.png";
import image36 from "../../assets/images/idn/image36.png";

import { BackButton } from "../common/BackButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import CopyToClipboard from "react-copy-to-clipboard";
import copy from "../../assets/images/icon_topup/copy.svg";
import { toast } from "react-toastify";
import { getTutorialApi } from "../../core/service/api_topup";
import { useAppSelector } from "../../core/feature/hooks";
import {
  getBankDisplayIcon,
  getBankDisplayName,
} from "../ComponentTopup/topupBankUtils";

const ComponentTopupTutorial = () => {
  const [tutor, setTutor] = useState<any>({});
  const navigate = useNavigate();

  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [kodeFull, setKodeFull] = useState("");
  const [kodeInstitusi, setKodeInstitusi] = useState("");
  const [kodeBayar, setKodeBayar] = useState("");
  const location: any = useLocation();
  const [stateData, setStateData] = useState<any>(location?.state?.data);
  const [tutorial, setTutorial] = useState("");
  const language: String = useAppSelector((state) => state.language.language);
  const [dataa, setData] = useState<any>([
    {
      id: "1",
      title: "Pembayaran Melalui BSI Mobile",
      logo: bsi,
      description: [
        {
          message: "Pilih menu Pembayaran/Payment",
        },
        {
          message: "Pilih Akademik",
        },
        {
          message: "Masukan kode institusi {{kodeInstitusi}}{{copyInstitusi}}",
        },
        {
          message: "Masukan ID Pelanggan/Kode Bayar {{kodeBayar}}{{copyBayar}}",
        },
        {
          message: "Pilih selanjutnya",
        },
        {
          message: "Masukan nominal yang akan di top up kedalam aplikasi",
        },
        {
          message: "Masukan PIN",
        },
        {
          message: "Konfirmasi transaksi",
        },
        {
          message: "Selesai",
        },
      ],
    },
    {
      id: "2",
      title: "Pembayaran Melalui ATM BSI",
      logo: bsi,
      description: [
        {
          message: "Pilih Menu Payment / Pembayaran / Pembelian",
        },
        {
          message: "Pilih Akademik",
        },
        {
          message:
            "Masukan kode institusi {{kodeInstitusi}} + Masukkan Nomor ID Pelanggan {{kodeBayar}}{{copyFull}}",
        },
        {
          message: "Pilih Benar/Selanjutnya",
        },
        {
          message:
            "Kemudian tampil informasi data transaksi anda, pastikan data sudah benar",
        },
        {
          message: "Pilih Benar / Ya",
        },
      ],
    },

    {
      id: "3",
      title: "Pembayaran Melalui ATM Bank Lain",
      logo: bsi,
      description: [
        {
          message: "Pilih Transfer",
        },
        {
          message: "Pilih Antar Bank Online / Transfer Online antar Bank",
        },
        {
          message: "Masukan kode BSI 451 atau pilih Bank Mandiri Syariah",
        },
        {
          message:
            "Masukan kode 900 (paten) + kode institusi {{kodeInstitusi}} + ID Pelanggan {{kodeBayar}}{{copyFull}}",
        },
        {
          message: "Masukan nominal tagihan",
        },
        {
          message:
            "Layar akan menampilkan data transaksi anda, jika sudah benar pilih YA (OK)",
        },
        {
          message: "Selesai",
        },
      ],
    },
  ]);

  const onCopy = useCallback(() => {
    setCopied(true);
    toast(t("TOPUP.VACopied"));
  }, []);

  useEffect(() => {
    let inputStr = location?.state?.va;
    console.log(inputStr);
    setStateData((prev: any) => ({
      ...prev,
      icon: getBankDisplayIcon(prev?.bankName, prev?.icon),
      name: getBankDisplayName(prev?.bankName, prev?.name),
    }));
    setKodeFull(inputStr);
    setKodeInstitusi(inputStr.slice(3, 7));
    setKodeBayar(inputStr.slice(7));
    getTutorial();
  }, []);

  const getTutorial = async () => {
    getTutorialApi(stateData?.bankName, stateData?.vaNumber, language).then((res) => {
      setTutorial(res.data.length ? res.data[0].tutorial : "");
    });
  };
  return (
    <div className="font-montserrat bg-psp-primary">
      <StatsInvoice />
      <div className="p-3">
        <button
          onClick={() => {
            navigate("/topup");
          }}
          className="h-auto w-auto px-3 py-2 bg-psp-primary rounded-lg justify-center items-center mr-2"
        >
          <FontAwesomeIcon
            size="1x"
            icon={faChevronLeft}
            className=" cursor-pointer"
          />
        </button>
      </div>
      <div className="w-full container pt-4 flex flex-col gap-5">
        {
          stateData?.initial === "IDN" ? (
            <>
              <div className="w-full p-3">
                <div>
                  <div className="border-t-2 border-slate-300 mt-4 pt-4 text-[1vw]">
                    <p className="font-semibold text-[1.5vw] capitalize">
                      Alfamart{" "}
                    </p>
                    <p>
                      1. Informasikan ke kasir bahwa anda hendak melakukan
                      pembayaran Jaringan IDN, kemudian sebutkan Kode IDN
                      (menyesuaikan setiap company) dan Nomor Akun (account
                      number siswa)
                    </p>
                    <p>
                      2. Pastikan data yang kasir informasikan valid dan total
                      nominal top up sudah benar.
                    </p>
                    <p>
                      3. Bayar sejumlah nominal top up yang telah anda inputkan
                      menggunakan uang tunai
                    </p>
                    <p>
                      4.Selanjutnya anda akan menerima struk pembayaran sebagai
                      bukti bahwa transaksi anda berhasil diproses
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full p-3">
                <div>
                  <div className="border-t-2 border-slate-300 mt-4 pt-4 text-[1vw]">
                    <p className="font-semibold text-[1.5vw] capitalize">
                      Gopay
                    </p>
                    <p>1. Pada aplikasi Gojek silahkan pilih menu Go Tagihan</p>
                    <img src={image15} alt="" />
                    <p>2. Pilih menu Biaya Pendidikan</p>
                    <img src={image18} alt="" />
                    <p>
                      3. Silahkan input "TKI (Teknologi Kartu Indonesia)" pada
                      kolom pencarian
                    </p>
                    <img src={image19} alt="" />
                    <p>
                      4. Masukkan nomor akun anda{" "}
                      <CopyToClipboard onCopy={onCopy} text={kodeFull}>
                        <div>
                          <span className=" inline-block  text-psp-primary oldstyle-nums">
                            {kodeFull}
                          </span>
                          <img
                            src={copy}
                            className=" inline-block h-3 w-3"
                            alt=""
                          />
                        </div>
                      </CopyToClipboard>
                      pada kolom ID Pelajar
                    </p>
                    <img src={image20} alt="" />

                    <p>
                      5. Pastikan data transaksi anda sudah benar, lalu lakukan
                      pembayaran dengan menggunakan saldo GOPAY dan klik tombol
                      konfirmasi
                    </p>
                    <img src={image22} alt="" />
                  </div>
                </div>
              </div>
              <div className="w-full p-3">
                <div>
                  <div className="border-t-2 border-slate-300 mt-4 pt-4 text-[1vw]">
                    <p className="font-semibold text-[1.5vw] capitalize">
                      Tokopedia
                    </p>
                    <p>
                      1. Pada aplikasi Tokopedia, pilih Menu Top-up & Tagihan
                    </p>
                    <img src={image25} alt="" />
                    <p>2. Pilih menu Biaya Pendidikan</p>
                    <img src={image27} alt="" />
                    <p>3. Pada bagian cluster silahkan pilih Kursus</p>
                    <img src={image28} alt="" />
                    <p>
                      4. Pilih TKI (Teknologi Kartu Indonesia) pada bagian
                      Institusi Pendidikan
                    </p>
                    <img src={image31} alt="" />
                    <p>
                      5. Input nomor akun anda{" "}
                      <CopyToClipboard onCopy={onCopy} text={kodeFull}>
                        <div>
                          <span className=" inline-block  text-psp-primary oldstyle-nums">
                            {kodeFull}
                          </span>
                          <img
                            src={copy}
                            className=" inline-block h-3 w-3"
                            alt=""
                          />
                        </div>
                      </CopyToClipboard>
                      pada kolom Nomor Pembayaran atau Nomor Mahasiswa, lalu
                      klik tombol Cek Tagihan
                    </p>
                    <img src={image32} alt="" />

                    <p>
                      6. Pastikan data transaksi anda sudah benar, lalu lakukan
                      pembayaran dengan menggunakan metode yang anda inginkan
                      dan klik tombol Bayar.
                    </p>
                    <img src={image33} alt="" />
                    <img src={image34} alt="" />
                    <p>
                      7. Pembayaran selesai. Selanjutnya, anda dapat menyimpan
                      atau mengirimkan bukti pembayaran tersebut.
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full p-3">
                <div>
                  <div className="border-t-2 border-slate-300 mt-4 pt-4 text-[1vw]">
                    <p className="font-semibold text-[1.5vw] capitalize">
                      Blibli
                    </p>
                    <p>
                      1. Pada aplikasi/web Blibli, pilih Menu Tagihan & Isi
                      Ulang
                    </p>
                    <img src={image7} alt="" />
                    <p>2. Pilih menu Pendidikan</p>
                    <img src={image8} alt="" />
                    <p>
                      3. ​Pada kolom institusi silahkan pilih TKI (Teknologi
                      Kartu Indonesia) dengan menginputkan pada kolom pencarian
                      yang tersedia
                    </p>
                    <img src={image10} alt="" />

                    <p>
                      4. Input nomor akun anda{" "}
                      <CopyToClipboard onCopy={onCopy} text={kodeFull}>
                        <div>
                          <span className=" inline-block  text-psp-primary oldstyle-nums">
                            {kodeFull}
                          </span>
                          <img
                            src={copy}
                            className=" inline-block h-3 w-3"
                            alt=""
                          />
                        </div>
                      </CopyToClipboard>
                      pada kolom Nomor Pelajar, lalu klik tombol Lihat Tagihan
                    </p>
                    <img src={image11} alt="" />

                    <p>
                      5. Pastikan data transaksi anda sudah benar, lalu klik
                      tombol Lanjut Bayar.
                    </p>
                    <img src={image12} alt="" />
                    <p>
                      6. Pilih metode pembayaran yang anda inginkan, lalu klik
                      Bayar
                    </p>
                    <img src={image13} alt="" />
                    <p>
                      7. Pembayaran selesai. Selanjutnya, anda dapat menyimpan
                      atau mengirimkan bukti pembayaran tersebut.
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full p-3">
                <div>
                  <div className="border-t-2 border-slate-300 mt-4 pt-4 text-[1vw]">
                    <p className="font-semibold text-[1.5vw] capitalize">
                      Shopee
                    </p>
                    <p>
                      1. Pada aplikasi Shopee, pilih Menu Pulsa, Tagihan, dan
                      Tiket
                    </p>
                    <img src={image36} alt="" />
                    <p>2. Pada bagian Tagihan, pilih Menu Biaya Pendidikan</p>
                    <img src={image1} alt="" />
                    <p>3. Tekan Pilih Institusi</p>
                    <img src={image2} alt="" />
                    <p>
                      4. Input TKI (Teknologi Kartu Indonesia) pada kolom
                      pencarian
                    </p>
                    <img src={image3} alt="" />
                    <p>
                      5. Input nomor akun anda{" "}
                      <CopyToClipboard onCopy={onCopy} text={kodeFull}>
                        <div>
                          <span className=" inline-block  text-psp-primary oldstyle-nums">
                            {kodeFull}
                          </span>
                          <img
                            src={copy}
                            className=" inline-block h-3 w-3"
                            alt=""
                          />
                        </div>
                      </CopyToClipboard>
                      pada kolom Nomor Pelajar, lalu klik tombol Lihat Tagihan
                    </p>
                    <img src={image4} alt="" />

                    <p>
                      6. Pastikan data transaksi anda sudah benar, lalu klik
                      Lanjutkan..
                    </p>
                    <img src={image5} alt="" />
                    <p>
                      7. Pilih metode pembayaran yang diinginkan, lalu klik
                      Bayar Sekarang
                    </p>
                    <img src={image6} alt="" />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <span className="text-sm font-bold">Panduan</span>
              <iframe
                srcDoc={tutorial}
                style={{ width: "100%", height: "100vh", border: "none" }}
                title="HTML Content"
              />
            </>
          )
          // dataa.map((resData: any, ind: any) => (
          //   <div className="w-1/3 p-3" key={ind}>
          //     <div>
          //       <div className="flex justify-start">
          //         <img
          //           src={resData.id == "3" ? bersama : bsi}
          //           alt="bank"
          //           className="w-40 max-h-11"
          //         />
          //       </div>
          //       <div className="border-t-2 border-slate-300 mt-4 pt-4 text-[1vw]">
          //         <p
          //           className={`font-bold text-[1.5vw] capitalize ${resData.id === "1"
          //             ? "text-[#00a398]"
          //             : resData.id === "2"
          //               ? "text-[#f8ad3c]"
          //               : resData.id === "3"
          //                 ? "text-[#018ffe]"
          //                 : ""
          //             }`}
          //         >
          //           {resData.title}
          //         </p>
          //         <ol className="flex flex-col gap-3 list-decimal list-outside mt-3">
          //           {resData.description.map((desc: any) => (
          //             <li className="text-sm font-normal leading-6 ">
          //               {String(desc.message)
          //                 .replaceAll("{{kodeInstitusi}}", kodeInstitusi)
          //                 .replaceAll("{{kodeBayar}}", kodeBayar)
          //                 .replaceAll("{{copyFull}}", "")
          //                 .replaceAll("{{copyInstitusi}}", "")
          //                 .replaceAll("{{copyBayar}}", "")}
          //               {desc.message.includes("{{copyFull}}") ? (
          //                 <CopyToClipboard onCopy={onCopy} text={kodeFull}>
          //                   <div>
          //                     <span className=" inline-block  text-psp-primary oldstyle-nums">
          //                       {kodeFull}
          //                     </span>
          //                     <img
          //                       src={copy}
          //                       className=" inline-block h-3 w-3"
          //                       alt=""
          //                     />
          //                   </div>
          //                 </CopyToClipboard>
          //               ) : desc.message.includes("{{copyInstitusi}}") ? (
          //                 <CopyToClipboard onCopy={onCopy} text={kodeInstitusi}>
          //                   <div>
          //                     <span className=" inline-block  text-psp-primary oldstyle-nums">
          //                       {kodeInstitusi}
          //                     </span>
          //                     <img
          //                       src={copy}
          //                       className=" inline-block h-3 w-3"
          //                       alt=""
          //                     />
          //                   </div>
          //                 </CopyToClipboard>
          //               ) : desc.message.includes("{{copyBayar}}") ? (
          //                 <CopyToClipboard onCopy={onCopy} text={kodeBayar}>
          //                   <div>
          //                     <span className=" inline-block  text-psp-primary oldstyle-nums">
          //                       {kodeBayar}
          //                     </span>
          //                     <img
          //                       src={copy}
          //                       className=" inline-block h-3 w-3"
          //                       alt=""
          //                     />
          //                   </div>
          //                 </CopyToClipboard>
          //               ) : (
          //                 ""
          //               )}
          //             </li>
          //           ))}
          //         </ol>
          //         {/* <p>1. Pilih menu Pembayaran/Payment</p>
          //     <p>2. Pilih Akademik</p>
          //     <p>
          //       3. Masukan kode institusi{" "}
          //       <span className="text-blue-400">5602</span>
          //     </p>
          //     <p>4. Masukan id Pelanggan/Kode Bayar</p>
          //     <p>5. Pilih Selanjutnya</p>
          //     <p>6. Masukan nominal yang akan di top up kedalam aplikasi</p>
          //     <p>7. Masukan PIN</p>
          //     <p>8. Konfirmasi Transaksi</p>
          //     <p>9. Selesai</p> */}
          //       </div>
          //     </div>
          //   </div>
          // ))
        }
      </div>
    </div>
  );
};

export default ComponentTopupTutorial;
